import stickyHeaderInit from './zzero/sticky-header';
import mobileNavigationInit from './zzero/mobile-nav';
import navDropdownInit from './zzero/dropdowns';

document.addEventListener('DOMContentLoaded', () => {
  stickyHeaderInit();
  mobileNavigationInit();

  if (document.querySelector('.nav')) {
    navDropdownInit();
  }
});